import { render, staticRenderFns } from "./districtControllerForm.vue?vue&type=template&id=33011546&scoped=true&"
import script from "./districtControllerForm.vue?vue&type=script&lang=js&"
export * from "./districtControllerForm.vue?vue&type=script&lang=js&"
import style0 from "./districtControllerForm.vue?vue&type=style&index=0&id=33011546&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33011546",
  null
  
)

export default component.exports